// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import { translations, translateFunc } from '../shared/localize'
import type { OptionType, GroupedOptionType, AutomatedRuleTableData } from './types'

import { Table, HeaderCell, HeaderRow } from '../components/MainTable'
import Button from './controls/PrimaryButton'
import AutomatedRulesTableRow from './AutomatedRulesTable/AutomatedRulesTableRow'
import styled from 'styled-components'
import postJson from '../services/postJson'

const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -14px;
`

const TopButton: typeof Button = (styled(Button): any).attrs({ small: true })`
  margin-left: 14px;
`

type Props = {|
  locale: string,
  automatedRules: Array<AutomatedRuleTableData>,
  audienceOptions: Array<GroupedOptionType>,
  actionOptions: Array<OptionType>,
  conditionOptions: Array<OptionType>
|}

type State = {|
  automatedRules: Array<AutomatedRuleTableData>,
  checked: { [number]: boolean }
|}

const AutomatedRulePath = '/api/v1/automated_rules'
const NewRulePath = '/automated_rules/new'
const ShowRuleLogsPath = '/automated_rules_logs'

export default class AutomatedRulesTable extends Component<Props, State> {
  table: any
  t: Function

  constructor(props: Props) {
    super(props)

    this.t = translateFunc(
      { ...translations.automated_rules_table, ...translations.provider_short_translations },
      { locale: props.locale }
    )
    this.state = {
      automatedRules: props.automatedRules,
      checked: this.initialChecked()
    }
  }

  render() {
    let state = this.state

    return (
      <div>
        <ButtonWrapper>
          <TopButton href={NewRulePath}>{this.t('new')}</TopButton>
          <TopButton href={ShowRuleLogsPath}>{this.t('logs')}</TopButton>
        </ButtonWrapper>
        <Table
          className="t-AutomatedRulesTable"
          ref={(el) => {
            this.table = el
          }}
        >
          <thead>
            <HeaderRow>
              <HeaderCell />
              <HeaderCell>#</HeaderCell>
              <HeaderCell alignLeft>{this.t('header.name')}</HeaderCell>
              <HeaderCell alignLeft>{this.t('header.providers')}</HeaderCell>
              <HeaderCell alignLeft>{this.t('header.audiences')}</HeaderCell>
              <HeaderCell alignLeft>{this.t('header.conditions_action')}</HeaderCell>
              <HeaderCell alignLeft>{this.t('header.frequency')}</HeaderCell>
              <HeaderCell>{this.t('header.options')}</HeaderCell>
            </HeaderRow>
          </thead>
          <tbody>
            {state.automatedRules.map((rule) => (
              <AutomatedRulesTableRow
                key={rule.id}
                t={this.t}
                rule={rule}
                audienceOptions={this.props.audienceOptions}
                conditionOptions={this.props.conditionOptions}
                actionOptions={this.props.actionOptions}
                checked={this.state.checked[rule.id]}
                onChange={(state) => this.updateCheckedState(rule.id, state)}
                onDelete={(rule) => this.deleteRule(rule)}
              />
            ))}
          </tbody>
        </Table>
      </div>
    )
  }

  initialChecked(): Object {
    const { automatedRules } = this.props
    return _.fromPairs(_.map(automatedRules, (rule) => [rule.id, rule.state]))
  }

  updateCheckedState(id: number, state: boolean) {
    let checked = this.state.checked
    checked[id] = state
    this.setState({ checked })
  }

  deleteRule(rule: AutomatedRuleTableData) {
    if (rule.id && window.confirm(this.t('are_you_sure', { name: rule.name }))) {
      postJson(AutomatedRulePath + '/' + rule.id + '/delete').done(() => {
        this.setState({ automatedRules: _.without(this.state.automatedRules, rule) })
      })
    }
  }
}
